import { PayloadAction } from '@reduxjs/toolkit'
import { GenericOperationState, isOperationResponseComplete } from '@repo/core'
import { DeviceListParams, DeviceType, UpdateDeviceAliasParams } from '@repo/user-types'
import { getContext, put, take, takeLatest } from 'redux-saga/effects'
import {
  addTrustDeviceActions,
  deleteDeviceSigningDataActions,
  deleteDeviceTrustedDataActions,
  devicesDataActions,
  deviceSigningDataActions,
  updateDeviceAliasActions,
  userPreferencesDataActions,
} from '../../slices'
import { deviceActions } from '../../store/actions'

function getAfterModifyDeviceListActionsSaga(deviceType: DeviceType) {
  return function* onAfterModifyDeviceListActions({
    error,
    meta,
  }: PayloadAction<null> & GenericOperationState<any>) {
    if (!error && isOperationResponseComplete(meta)) {
      yield put(devicesDataActions.getRequest({ type: deviceType }))
      yield put(userPreferencesDataActions.getRequest())
    }
  }
}

function* closeAlertDialogOnSuccess({
  error,
  meta,
}: PayloadAction<null> & GenericOperationState<any>) {
  if (!error && meta?.httpCode === 202) {
    const closeDialog: (() => void) | undefined = yield getContext('closeAlertDialog')
    if (closeDialog) {
      closeDialog()
    }
  }
}
export function* watchCloseDialogOnSuccess() {
  yield takeLatest(
    [
      deleteDeviceSigningDataActions.deleteResponse.type,
      deleteDeviceTrustedDataActions.deleteResponse.type,
      addTrustDeviceActions.postResponse.type,
    ],
    closeAlertDialogOnSuccess,
  )
}

function* saveDeviceEditAlias({
  payload,
}: PayloadAction<UpdateDeviceAliasParams & DeviceListParams>) {
  const { type, ...params } = payload
  yield put(updateDeviceAliasActions.putRequest(params))

  const response: GenericOperationState<null> = yield take(
    updateDeviceAliasActions.putResponse.type,
  )

  if (!response.error && response.meta?.httpCode !== 202) {
    yield put(devicesDataActions.getRequest({ type }))
    const closeDialog: (() => void) | undefined = yield getContext('closeDialog')
    if (closeDialog) {
      closeDialog()
    }
  }
}

export function* watchDeviceActions() {
  yield takeLatest(
    [
      deleteDeviceSigningDataActions.deleteResponse.type,
      deviceSigningDataActions.postResponse.type,
    ],
    getAfterModifyDeviceListActionsSaga(DeviceType.SIGNING),
  )
  yield takeLatest(
    [deleteDeviceTrustedDataActions.deleteResponse.type, addTrustDeviceActions.postResponse.type],
    getAfterModifyDeviceListActionsSaga(DeviceType.TRUSTED),
  )
  yield takeLatest(deviceActions.saveEditAlias.type, saveDeviceEditAlias)
}
